import { useLocation } from '@remix-run/react';

import Icon from '~/components/icon';
import {
  type BaseNavItem,
  type SecondLevelNavItem,
  type ThirdLevelNavItem } from
'~/interfaces/HeaderFooterNavV2';

import styles from './HeaderNavItem.module.css';

interface HeaderNavItemProps {
  variant: 'primary' | 'secondary' | 'tertiary';
}

type HeaderNavItem =
(BaseNavItem & {variant: 'primary';}) |
(SecondLevelNavItem & {variant: 'secondary';}) |
(ThirdLevelNavItem & {variant: 'tertiary';});

type THeaderNavItem = React.FunctionComponent<
  HeaderNavItem & HeaderNavItemProps>;


export const HeaderNavItem: THeaderNavItem = (props) => {
  const { link, name, type, variant } = props;
  const location = useLocation();

  if (type !== 'LINK') {
    return null;
  }

  const renderIcon = () => {
    if (variant === 'secondary') {
      const { icon } = props;

      return icon ?
      <Icon className={styles.icon} height={22} icon={icon} width={22} /> :
      null;
    }

    return null;
  };

  return (
    <li
      className={`${styles[variant]} ${styles.itemWrapper} ${link === location.pathname ? styles.selected : ''}`}
      key={link}>

			{renderIcon()}
			<a className={styles.item} href={link}>
				{name}
			</a>
		</li>);

};